import { ReportContasReceberAnaliticoColumnsForm } from "../../../presentation/schemas/reports/contasReceberAnaliticoReport";
import { ISaveContasReceberAnaliticoFiltrosUseCase } from "../../../presentation/useCases/create/save_contas_receber_analitico_filtros_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * SaveContasReceberAnaliticoFiltrosUseCase
 */

export class SaveContasReceberAnaliticoFiltrosUseCase implements ISaveContasReceberAnaliticoFiltrosUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }


  async saveContasReceberAnaliticoFiltros(
    form: ReportContasReceberAnaliticoColumnsForm
  ): Promise<void> {
    var listaStr: string[] = [];

    if (form.nroContasPagar) { listaStr.push('NR_CONTAS_PAGAR'); }
    if (form.centroCusto) { listaStr.push('CENTRO_CUSTO'); }
    if (form.bancoPagamento) { listaStr.push('BANCO_PAGAMENTO'); }
    if (form.notaFiscal) { listaStr.push('NOTA_FISCAL'); }
    if (form.nroDocumento) { listaStr.push('NRO_DOCUMENTO'); }
    if (form.status) { listaStr.push('STATUS'); }
    if (form.titulo) { listaStr.push('TITULO'); }
    if (form.dataPagar) { listaStr.push('DATA_PAGAR'); }
    if (form.dataPago) { listaStr.push('DATA_PAGO'); }
    if (form.valorPagar) { listaStr.push('VALOR_A_PAGAR'); }
    if (form.valorPago) { listaStr.push('VALOR_PAGO'); }
    if (form.observacao) { listaStr.push('OBSERVACOES'); }
    if (form.subconta) { listaStr.push('SUBCONTA'); }
    if (form.cliente) { listaStr.push('CLIENTE'); }
    if (form.nroContratoFinanceiro) { listaStr.push('NRO_CONTRATO_FINANCEIRO'); }
    if (form.juros) { listaStr.push('JUROS'); }
    if (form.desconto) { listaStr.push('DESCONTO'); }
    if (form.multa) { listaStr.push('MULTA'); }
    if (form.bdi) { listaStr.push('BDI'); }
    if (form.bdi2) { listaStr.push('BDI2'); }
    if (form.bdiTotal) { listaStr.push('BDI_TOTAL'); }
    if (form.bdiTotal2) { listaStr.push('BDI_TOTAL2'); }
    if (form.dataCriacao) { listaStr.push('DATA_CRIACAO'); }
    if (form.dataCompetencia) { listaStr.push('DATA_COMPETENCIA'); }

    await this.repository.saveContasReceberAnaliticoFiltros(listaStr.join(','));

  }

}
